import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FilterMatchMode } from 'primeng/api';

@Component({
  selector: 'app-basic-filter',
  templateUrl: './basic-filter.component.html',
  styleUrls: ['./basic-filter.component.css']
})
export class BasicFilterComponent implements OnInit {
  @Input() public field: any;
  @Input() table: any;
  @Input() filters: any;
  filterFormGroup: FormGroup;
  @Output() applyFilter: EventEmitter<any> = new EventEmitter<any>();
  matchModeOptions = [
    { label: "Custom Equals", value: "custom-equals" },
    { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
    { label: "Contains", value: FilterMatchMode.CONTAINS }
  ];
  constructor(private _fb: FormBuilder) { }

  ngOnInit(): void {
    this.initialSetup();
  }

  initialSetup() {
    this.filterFormGroup = this._fb.group({
      matchModeControl: new FormControl('contains'),
      valueControl: new FormControl(null, [Validators.required])
    })
  }

  apply(formGroup, fieldName) {
    let value = formGroup.value;
   // if ((this.table.filters[fieldName][0].value != value.valueControl) || (this.table.filters[fieldName][0].matchMode != value.matchModeControl)) {
      this.table.filters[fieldName][0].value = value.valueControl;
      this.table.filters[fieldName][0].matchMode = value.matchModeControl;
      this.table.filters[fieldName][0].operator = 'and';
      this.filters = this.table.filters;
      this.applyFilter.emit();
   // }
  }

  clear(fieldName) {
    this.initialSetup();
    for (let i = 0; i < this.table.filters[fieldName].length; i++) {
      this.table.filters[fieldName][i].value = null;
      this.table.filters[fieldName][i].matchMode = null;
      this.table.filters[fieldName][i].operator = null;
    }
    this.filters = this.table.filters;
    this.applyFilter.emit();
  }

  filterOpen(form: FormGroup, fieldName, control1, control2) {
    if (this.table.filters[fieldName] != undefined) {
      for (let i = 0; i < this.table.filters[fieldName].length; i++) {
        if (this.table.filters[fieldName][i].matchMode == null || this.table.filters[fieldName][i].value == null) {
          this.initialSetup();
        } else {
          form.controls[control1].setValue(this.table.filters[fieldName][i].matchMode);
          form.controls[control2].setValue(this.table.filters[fieldName][i].value)
        }
      }
    }
  }
}
